module.exports = __webpack_public_path__ + "static/media/location-img-2.8dcf5145.jpg";